<template>
  <ReviewMenuWithLabels
    link_to="/graded-annotation-reviews/"
    title="Graded Annotation Reviews"
  />
</template>

<script>
import ReviewMenuWithLabels from "@/components/review/ReviewMenuWithLabels";
import Store from "./GradedAnnotationReviews.store";

export default {
  components: { ReviewMenuWithLabels },
  created() {
    this.$store.loadStoreModule({ module: Store });
  },
};
</script>